/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEyeClosed: {
  name: 'eye-closed';
  data: string;
} = {
  name: 'eye-closed',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 11c2.444 0 5.149-1.499 6.748-4.496a.805.805 0 0 0-.104-.936C13.873 4.738 11.805 3 8 3S2.127 4.737 1.356 5.568a.805.805 0 0 0-.104.936C2.852 9.5 5.556 11 8 11ZM8 13v-2M13.5 11.5 12 10M2 11.5 3.5 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
